<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <DetailForm ref="detailForm" />
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import DetailForm from './detail';
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  invoiceRegisterEdit,
  invoiceRegisterDetail,
} from 'api/operate';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    DetailForm,
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/operate/invoice/register/edit',
      formComponents: ['baseForm', 'detailForm'],
    };
  },
  computed: {
    detailParams () {
      return {
        flowId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: invoiceRegisterDetail,
    editApi: invoiceRegisterEdit,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
